import React from 'react'
import ButtonStyled from '../../components/CommonUI/Button/Button'
import House from '../../components/CommonUI/svgIcons/House'
import Smile from '../../components/CommonUI/svgIcons/Smile'
import { Link } from 'react-router-dom'
import {routingConstants} from '../../constants/routingConstants'
import {useShallowEqualSelector} from '../../custom-hooks'
import {getProfileGroupsSelector} from '../../redux/reducers/profile'

export default function PageNotFound() {
    const [firstGroup] = useShallowEqualSelector(getProfileGroupsSelector)

  return (
    <div className='holder-content'>
      <div className='wrapper'>
        <h1 className='page-title main-title'>404</h1>
        <p className='page-text text-padding main-text'>
          <span className='text'>The page you requested was not found</span>
          <Smile />
        </p>
      </div>
      <div className='button-wrapper pt-4'>
        <Link to={`${routingConstants.overview}/${firstGroup?.id}`} className='button-link'>
          <ButtonStyled>
            <p className='button-text'>
              <House />
              <span className='text-button'>Back to home page</span>
            </p>
          </ButtonStyled>
        </Link>
      </div>
    </div>
  )
}